/**
 * Constants used in app-main
 */
export const TRIP_NAME__DEFAULT = 'Trip';

export const SHARING_MESSAGE__LOADING = 'Loading ...';
export const SHARING_MESSAGE__ERROR =
  'Something went wrong. Try sharing again.';
export const SHARING_MESSAGE__NOTIFICATIONS_ERROR =
  'There was a problem loading your notifications.';
export const SHARING_MESSAGE__NO_SUGGESTIONS_FOUND =
  'Sorry no suggestions found.';
export const SHARING_MESSAGE__LOOKING_FOR_SUGGESTIONS =
  'Looking for suggestions ...';
export const SHARING_MESSAGE__NO_NOTIFICATIONS_HEADING =
  'You have no notifications';
export const SHARING_MESSAGE__NO_NOTIFICATIONS_MESSAGE =
  'When someone shares content on Deckee with you, a notification will appear here.';
export const SHARING_MESSAGE__COPY_LINK = 'Link copied to clipboard!';

export const BREAKPOINT_WIDTH__TABLET = 800;

export const MAP_PADDING__DEFAULT = {
  defaultWidth: 50,
  mobileWidth: 20,
};

/**
 * Constants used in float-plan screens
 */
export const FLOAT_PLAN__FILTER_SHARE = {
  created: 'created',
  shared: 'shared',
};

export const FLOAT_PLAN__FILTER_STATUS = {
  all: 'created',
  active: 'active',
  overdue: 'overdue',
  complete: 'complete',
};

export const FLOAT_PLAN__STATUS = {
  active: 'Due in',
  complete: 'Complete',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
};

/**
 * Hard coded container dimensions used for calculating map padding
 *  - dimensions are either a number in px or a width 100% as a string
 *  - if using 100% then this is in relation to the window inner dimensions
 *
 * NOTE: These are being used as it is not currently reliable to generate on component rendering.
 *   This will potentially be changed once we implement a new mapbox wrapper and remove the 'HACK'
 */
export const DOM_ELEMENT_DIMENSIONS__PAGE_HOLDER_STICKY_HEADER = {
  default: {
    width: 390,
    height: 61,
  },
  mobile: {
    width: '100%',
    height: 61,
  },
};

export const DOM_ELEMENT_DIMENSIONS__PAGE_HOLDER_PANEL = {
  default: {
    width: 400,
    height: '100%',
  },
  mobile: {
    width: '100%',
    height: '100%',
  },
};

export const DOM_ELEMENT_DIMENSIONS__TRIP_SAVE_PANEL = {
  default: {
    width: 390,
    height: 336,
  },
  mobile: {
    width: '100%',
    height: 336,
  },
};

export const DOM_ELEMENT_DIMENSIONS__TRIP_PANEL_DEFAULT = {
  default: {
    width: 390,
    height: 273,
  },
  mobile: {
    width: '100%',
    height: 300,
  },
};

export const DOM_ELEMENT_DIMENSIONS__FLOAT_PLAN_TRIP_DEFAULT = {
  default: {
    width: '100%',
    height: 207,
  },
  mobile: {
    width: '100%',
    height: 300,
  },
};
